'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get3 = require('lodash/get');

var _get4 = _interopRequireDefault(_get3);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _auth = require('redux/modules/auth');

var _permissions = require('helpers/permissions');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _containers = require('containers');

var _components = require('components');

var _StatisticsProjects = require('containers/Statistics/StatisticsProjects/StatisticsProjects');

var _StatisticsProjects2 = _interopRequireDefault(_StatisticsProjects);

var _StatisticsRecipients = require('containers/Statistics/StatisticsRecipients/StatisticsRecipients');

var _StatisticsRecipients2 = _interopRequireDefault(_StatisticsRecipients);

var _Statistics = require('containers/Statistics/Statistics');

var _Statistics2 = _interopRequireDefault(_Statistics);

var _ProjectStatistics = require('containers/Statistics/ProjectStatistics/ProjectStatistics');

var _ProjectStatistics2 = _interopRequireDefault(_ProjectStatistics);

var _ProjectStatisticsOverall = require('containers/Statistics/ProjectStatisticsOverall/ProjectStatisticsOverall');

var _ProjectStatisticsOverall2 = _interopRequireDefault(_ProjectStatisticsOverall);

var _ProjectRecipientStatistics = require('containers/Statistics/ProjectRecipientStatistics/ProjectRecipientStatistics');

var _ProjectRecipientStatistics2 = _interopRequireDefault(_ProjectRecipientStatistics);

var _ProjectDetailsStatistics = require('containers/Statistics/ProjectDetailsStatistics/ProjectDetailsStatistics');

var _ProjectDetailsStatistics2 = _interopRequireDefault(_ProjectDetailsStatistics);

var _DevicesStatistics = require('containers/Statistics/DevicesStatistics/DevicesStatistics');

var _DevicesStatistics2 = _interopRequireDefault(_DevicesStatistics);

var _RecipientStatistics = require('containers/Statistics/RecipientStatistics/RecipientStatistics');

var _RecipientStatistics2 = _interopRequireDefault(_RecipientStatistics);

var _RecipientStatisticsOverall = require('containers/Statistics/RecipientStatisticsOverall/RecipientStatisticsOverall');

var _RecipientStatisticsOverall2 = _interopRequireDefault(_RecipientStatisticsOverall);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasPermission = function hasPermission(_ref) {
  var user = _ref.user,
      permissionField = _ref.permissionField;
  return permissionField ? (0, _get4.default)(user, ['rightMngt', permissionField]) : true;
};

var isUserTypeDenied = function isUserTypeDenied(_ref2) {
  var user = _ref2.user,
      _ref2$deniedUserTypes = _ref2.deniedUserTypes,
      deniedUserTypes = _ref2$deniedUserTypes === undefined ? [] : _ref2$deniedUserTypes;
  return deniedUserTypes.includes((0, _get4.default)(user, 'rightMngt.accType'));
};

var processRequireAuth = function processRequireAuth(_ref3) {
  var user = _ref3.user,
      permissionField = _ref3.permissionField,
      deniedUserTypes = _ref3.deniedUserTypes,
      replace = _ref3.replace;

  if (!user) {
    // oops, not logged in, so can't be here!
    replace(_config2.default.app.defaultRedirectRoute);
  } else if (!hasPermission({ user: user, permissionField: permissionField }) || isUserTypeDenied({ user: user, deniedUserTypes: deniedUserTypes })) {
    replace(_config2.default.app.defaultUserRoute);
  }
};

var processRequireGuest = function processRequireGuest(_ref4) {
  var user = _ref4.user,
      replace = _ref4.replace;

  if (user) {
    replace(_config2.default.app.defaultRedirectRoute);
  }
};

exports.default = function (store) {
  var requireRole = function requireRole(_ref5) {
    var requireAuth = _ref5.requireAuth,
        replace = _ref5.replace,
        cb = _ref5.cb,
        permissionField = _ref5.permissionField,
        deniedUserTypes = _ref5.deniedUserTypes;

    function checkAuth() {
      var _store$getState = store.getState(),
          user = _store$getState.auth.user;

      if (requireAuth) {
        processRequireAuth({ user: user, permissionField: permissionField, deniedUserTypes: deniedUserTypes, replace: replace });
      } else {
        processRequireGuest({ user: user, replace: replace });
      }
      cb();
    }

    if (!(0, _auth.isLoaded)(store.getState())) {
      store.dispatch((0, _auth.load)()).promise.then(checkAuth).catch(checkAuth);
    } else {
      checkAuth();
    }
  };

  var requireLogin = function requireLogin(nextState, replace, cb) {
    requireRole({ requireAuth: true, nextState: nextState, replace: replace, cb: cb });
  };

  var requireGuest = function requireGuest(nextState, replace, cb) {
    requireRole({ requireAuth: false, nextState: nextState, replace: replace, cb: cb });
  };

  var requireCreateProjectPermissions = function requireCreateProjectPermissions(nextState, replace, cb) {
    var _nextState$params = nextState.params,
        projectId = _nextState$params.projectId,
        type = _nextState$params.type;

    if (!Number(projectId)) {
      var permissionField = (0, _permissions.getRawPermissionsTypesFields)().createProject[type];
      requireRole({ requireAuth: true, nextState: nextState, replace: replace, cb: cb, permissionField: permissionField });
    } else {
      cb();
    }
  };

  var requireQuickSendPermissions = function requireQuickSendPermissions(nextState, replace, cb) {
    var permissionField = _permissions.permissionsMap.quickSendAccess;
    requireRole({ requireAuth: true, nextState: nextState, replace: replace, cb: cb, permissionField: permissionField });
  };

  var requireProjectsPermissions = function requireProjectsPermissions(nextState, replace, cb) {
    requireRole({ requireAuth: true, nextState: nextState, replace: replace, cb: cb, deniedUserTypes: _permissions.sectionDeniedUserTypes.projects });
  };

  var requireContactsPermissions = function requireContactsPermissions(nextState, replace, cb) {
    requireRole({ requireAuth: true, nextState: nextState, replace: replace, cb: cb, deniedUserTypes: _permissions.sectionDeniedUserTypes.contacts });
  };

  /**
   * Please keep routes in alphabetical order
   */
  return _react2.default.createElement(
    _reactRouter.Route,
    { path: '/', component: _containers.App, isLanding: true },
    _react2.default.createElement(_reactRouter.IndexRoute, { components: { mainChild: _containers.Home } }),
    _react2.default.createElement(_reactRouter.Route, { path: 'home', components: { mainChild: _containers.Home }, isLanding: true }),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'service', components: { mainChild: _containers.Service } },
      _react2.default.createElement(_reactRouter.Route, { path: 'confirm-email', components: { mainChild: _containers.EmailConfirm } }),
      _react2.default.createElement(_reactRouter.Route, { path: 'download', components: { mainChild: _containers.Download } })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'processing' },
      _react2.default.createElement(
        _reactRouter.Route,
        { path: 'cloudauth' },
        _react2.default.createElement(_reactRouter.Route, { path: 'dropbox', components: { mainChild: _containers.DropboxAuth } }),
        _react2.default.createElement(_reactRouter.Route, { path: 'boxcom', components: { mainChild: _containers.BoxcomAuth } })
      )
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'password', isLanding: true },
      _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'reset' }),
      _react2.default.createElement(_reactRouter.Route, { path: ':action', components: { mainChild: _containers.Home } })
    ),
    _react2.default.createElement(_reactRouter.Route, { path: 'login', components: { mainChild: _containers.Login }, onEnter: requireGuest }),
    _react2.default.createElement(_reactRouter.Route, { path: 'registration', components: { mainChild: _containers.Registration }, onEnter: requireGuest }),
    _react2.default.createElement(_reactRouter.Route, { path: 'contact-us', components: { mainChild: _containers.ContactUs } }),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'info', components: { mainChild: _containers.Info } },
      _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'terms-of-service' }),
      _react2.default.createElement(_reactRouter.Route, { path: 'terms-of-service', components: { mainChild: _components.TermOfService } }),
      _react2.default.createElement(_reactRouter.Route, { path: 'security', components: { mainChild: _components.Security } }),
      _react2.default.createElement(_reactRouter.Route, { path: 'copyright-policy', components: { mainChild: _components.CopyrightPolicy } }),
      _react2.default.createElement(_reactRouter.Route, { path: 'privacy-policy', components: { mainChild: _components.PrivacyPolicy } }),
      _react2.default.createElement(_reactRouter.Route, { path: 'cookie-policy', components: { mainChild: _components.CookiePolicy } }),
      _react2.default.createElement(_reactRouter.Route, { path: 'contact-us', components: { mainChild: _components.ContactUsInfo } })
    ),
    _react2.default.createElement(_reactRouter.Route, { path: 'playlists/fromkey/:key', components: { mainChild: _containers.Playlist } }),
    _react2.default.createElement(
      _reactRouter.Route,
      { onEnter: requireLogin },
      _react2.default.createElement(
        _reactRouter.Route,
        { path: 'playlists' },
        _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'all' }),
        _react2.default.createElement(_reactRouter.Route, { path: ':projectType', components: { mainChild: _containers.Playlists } }),
        _react2.default.createElement(_reactRouter.Route, { path: ':projectId/:recipientId', components: { mainChild: _containers.Playlist } })
      ),
      _react2.default.createElement(
        _reactRouter.Route,
        { path: 'my-playlists' },
        _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'all' }),
        _react2.default.createElement(_reactRouter.Route, { path: 'all', components: { mainChild: _containers.MyPlaylists } }),
        _react2.default.createElement(_reactRouter.Route, { path: 'new', components: { mainChild: _containers.MyPlaylist } }),
        _react2.default.createElement(_reactRouter.Route, { path: ':myPlaylistId', components: { mainChild: _containers.MyPlaylist } })
      ),
      _react2.default.createElement(_reactRouter.Route, { path: 'account', components: { mainChild: _containers.Account } }),
      _react2.default.createElement(_reactRouter.Route, { path: 'projects/new', components: { mainChild: _containers.NewProject } }),
      _react2.default.createElement(
        _reactRouter.Route,
        { path: 'projects', onEnter: requireProjectsPermissions },
        _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'all' }),
        _react2.default.createElement(_reactRouter.Route, { path: ':type', components: { mainChild: _containers.Projects } }),
        _react2.default.createElement(
          _reactRouter.Route,
          { path: ':type/:projectId', onEnter: requireCreateProjectPermissions },
          _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'info' }),
          _react2.default.createElement(_reactRouter.Route, { path: 'info', components: { mainChild: _containers.ProjectInfo } }),
          _react2.default.createElement(_reactRouter.Redirect, { from: '/projects/:type/0/*', to: '/projects' }),
          _react2.default.createElement(_reactRouter.Route, { path: 'materials', components: { mainChild: _containers.ProjectMaterials } }),
          _react2.default.createElement(_reactRouter.Route, { path: 'recipients', components: { mainChild: _containers.ProjectRecipients } }),
          _react2.default.createElement(_reactRouter.Route, { path: 'confirmation', components: { mainChild: _containers.ProjectConfirmation } }),
          _react2.default.createElement(_reactRouter.Route, { path: 'create', components: { mainChild: _containers.ProjectCreateFromSS } }),
          _react2.default.createElement(
            _reactRouter.Route,
            { path: 'report' },
            _react2.default.createElement(_reactRouter.IndexRoute, { components: { mainChild: _containers.ProjectReport } }),
            _react2.default.createElement(_reactRouter.Route, { path: ':recipientId', components: { mainChild: _containers.ProjectRecipientReport } })
          )
        )
      ),
      _react2.default.createElement(
        _reactRouter.Route,
        { path: 'statistics', components: { mainChild: _Statistics2.default } },
        _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'project' }),
        _react2.default.createElement(
          _reactRouter.Route,
          { path: 'project', referrer: 'project' },
          _react2.default.createElement(_reactRouter.IndexRoute, { components: { component: _StatisticsProjects2.default } }),
          _react2.default.createElement(
            _reactRouter.Route,
            { path: ':projectId', components: { component: _ProjectStatistics2.default } },
            _react2.default.createElement(_reactRouter.IndexRoute, { components: { component: _ProjectStatisticsOverall2.default } }),
            _react2.default.createElement(_reactRouter.Route, { path: 'details', components: { component: _ProjectDetailsStatistics2.default } }),
            _react2.default.createElement(_reactRouter.Route, { path: 'recipient/:recipientId', components: { component: _ProjectRecipientStatistics2.default } })
          )
        ),
        _react2.default.createElement(
          _reactRouter.Route,
          { path: 'recipient', referrer: 'recipient' },
          _react2.default.createElement(_reactRouter.IndexRoute, { components: { component: _StatisticsRecipients2.default } }),
          _react2.default.createElement(
            _reactRouter.Route,
            { path: ':recipientId', components: { component: _RecipientStatistics2.default } },
            _react2.default.createElement(_reactRouter.IndexRoute, { components: { component: _RecipientStatisticsOverall2.default } }),
            _react2.default.createElement(_reactRouter.Route, { path: 'project/:projectId', components: { component: _ProjectRecipientStatistics2.default } })
          )
        ),
        _react2.default.createElement(_reactRouter.Route, { path: 'devices', components: { component: _DevicesStatistics2.default } })
      ),
      _react2.default.createElement(
        _reactRouter.Route,
        { path: 'quick-send', onEnter: requireQuickSendPermissions },
        _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'inbox' }),
        _react2.default.createElement(_reactRouter.Route, { path: 'new', components: { mainChild: _containers.QuickSendNew } }),
        _react2.default.createElement(
          _reactRouter.Route,
          { path: ':type', components: { mainChild: _containers.QuickSend } },
          _react2.default.createElement(_reactRouter.IndexRoute, { components: { mainChild: _containers.QuickSendItem } }),
          _react2.default.createElement(_reactRouter.Route, { path: ':qsId', components: { mainChild: _containers.QuickSendItem } })
        )
      ),
      _react2.default.createElement(
        _reactRouter.Route,
        { path: 'contacts', onEnter: requireContactsPermissions },
        _react2.default.createElement(_reactRouter.IndexRoute, { components: { mainChild: _containers.Contacts } }),
        _react2.default.createElement(
          _reactRouter.Route,
          { path: 'groups' },
          _react2.default.createElement(_reactRouter.IndexRoute, { components: { mainChild: _containers.Groups } }),
          _react2.default.createElement(_reactRouter.Route, { path: ':groupId', components: { mainChild: _containers.GroupContacts } })
        )
      )
    ),
    _react2.default.createElement(_reactRouter.Route, { path: '*', components: { mainChild: _containers.NotFound }, status: 404 })
  );
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/routes.js
// module id = 2241
// module chunks = 1